export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.body = document.querySelector('body');
    this.dom.scroller = this.dom.el;

    this.dom.joinus = document.querySelector('[data-js="join-us"]');
    this.dom.boundary = document.querySelector('[data-js="change-boundary"]');
    this.dom.kaido = document.querySelector('[data-section="kaido"]');

    this.joinusPosition = 0;
    this.boundaryPosition = 0;
    this.kaidoPosition = 0;

    this.posPageHeader = 0;
    this.posPrevious = 0;
    this.hh = (this.dom.scroller) ? this.dom.scroller.clientHeight : 0;

    this.scrollAdj = 0;
    this.scrollTimeoutId = null;

    this.flagUp = (this.dom.body.dataset.scrollDirection === 'false') ? false : true;

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.update = this.update.bind(this);
    this.resize = this.resize.bind(this);

    this.init();
  }

  init() {
    setTimeout(() => {
      this.setVariable();
      this.update();
    }, 500)
    window.addEventListener('resize', this.resize);

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  update() {
    // let pyo = window.pageYOffset + this.hh - this.dom.scroller.clientHeight;
    let pyo = window.pageYOffset;
    pyo = pyo < 0 ? 0 : pyo;

    // スクロール方向の判定と静止タイマー
    if (pyo !== this.posPrevious) {
      if (pyo > this.posPrevious) {
        document.body.dataset.scrollDirection = 'down';
      } else if (pyo < this.posPrevious) {
        document.body.dataset.scrollDirection = 'up';
      }

      if (this.scrollTimeoutId) {
        clearTimeout(this.scrollTimeoutId);
      }
      this.scrollTimeoutId = setTimeout(() => {
        document.body.removeAttribute('data-scroll-direction');
      }, 1200);
    }

    this.flagUp = (this.dom.body.dataset.scrollAction !== 'true') ? false : true;

    if (pyo > this.posPageHeader) {
      document.body.style.setProperty('--header-animation-val', 0);
    } else {
      document.body.style.setProperty('--header-animation-val', '-100%');
    }

    if (pyo > window.innerHeight) {
      document.body.dataset.vh = 'over';
    } else {
      document.body.removeAttribute('data-vh')
    }

    // kaidoセクションが存在する場合（トップページのみ）のロゴサイズ制御
    if (this.dom.kaido) {
      if (pyo > this.kaidoPosition) {
        document.body.dataset.logo = 'small';
      } else {
        document.body.removeAttribute('data-logo');
      }
    }

    this.posPrevious = pyo;

    requestAnimationFrame(this.update);
  }

  // スクロールの基準となる位置を設定
  setVariable() {
    // ヘッダが隠れたと判断する位置
    this.hh = this.dom.scroller.clientHeight;

    if (this.dom.joinus) {
      let joinusRect = this.dom.joinus.getBoundingClientRect();
      this.joinusPosition = joinusRect.top + window.scrollY - window.innerHeight;
    }

    if (this.dom.boundary) {
      let boundaryRect = this.dom.boundary.getBoundingClientRect();
      this.boundaryPosition = boundaryRect.top + window.scrollY;
    }

    if (this.dom.kaido) {
      let kaidoRect = this.dom.kaido.getBoundingClientRect();
      this.kaidoPosition = kaidoRect.top + window.scrollY;
    }
  }

  resize() {
    this.setVariable();
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      this.posPageHeader = window.innerHeight * .5;
      return;
    } else {
      // console.log('pc');
      this.posPageHeader = 60;
      return;
		}
	}
}
